import { useQuery } from '../../../hooks/useQuery';
import * as colors from '../../../const/colors'
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Quotes } from './Quote/Quotes';
import { getAirlinesList, getCurrenciesList, getHotelsList, getWholesalersList, getCategoriesList
} from '../../../store/slices/general/thunks';
import { Passengers } from './Passenger/Passengers';
import { getIndividualFileById } from '../../../store/slices/individualFiles/thunks';
import { MasterSale } from './MasterSale/MasterSale';
import { resetMasterSale, setIndividualFile, setOptionSelected } from '../../../store/slices/individualFiles/individualFilesSlice';
import { Rooming } from './Rooming/Rooming';
import { Link, useNavigate } from 'react-router-dom';
import { Notes } from './Notes/Notes';

export const IndividualFileDetailsScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const id = (query.get("id")) ? query.get("id") : "";
  const { individualFile, masterSale, optionSelected } = useSelector((state) => state.individualFiles);

  useEffect(() => {
    if (id) {
      dispatch(getIndividualFileById(id))
    }
    return () => {
      dispatch(setIndividualFile({}));
    }
  }, [id])
  useEffect(() => {
    dispatch(getCurrenciesList());
  }, [])
  useEffect(() => {
    dispatch(getAirlinesList());
  }, [])
  useEffect(() => {
    dispatch(getWholesalersList());
  }, [])
  useEffect(() => {
    dispatch(getCategoriesList());
  }, [])
  useEffect(() => {
    dispatch(getHotelsList());
  }, [])
  useEffect(() => {
    return () => {
      dispatch(setOptionSelected("Quotes"))
      dispatch(resetMasterSale())
    }
  }, [])

  if(individualFile && individualFile.id == -1){    
    navigate("/panel/expedientes");
  }

  return (
    <div>
      <div style={{
        textAlign: "left",
        marginTop: 20,
        fontSize: 25,
        color: colors.title,
      }}>{`Expediente #${id}`} {`Grupo: ${individualFile.group2}`}
        <Link to={`/panel/expedienteGrupo?id=${individualFile.idGroup}`} style={{marginLeft: 20, textDecoration: 'underline' }}>Ir a grupo</Link>
      </div>

      <div className="d-flex" style={{ marginTop: 20, marginBottom: 20 }} >

        <button className={`btn text-white ${optionSelected === "Quotes" ? "btn-secondary" : "btn-primary"}`}
          onClick={() => dispatch(setOptionSelected("Quotes"))} >
          Cotizaciones
        </button>
        <button className={`btn text-white ${optionSelected === "Passengers" ? "btn-secondary" : "btn-primary"}`}
          onClick={() => dispatch(setOptionSelected("Passengers"))} >
          Pasajeros
        </button>
        {
          masterSale.isOpen === 0
          && <button className={`btn text-white ${optionSelected === "MasterSale" ? "btn-secondary" : "btn-primary"}`}
            onClick={() => dispatch(setOptionSelected("MasterSale"))} >
            Venta
          </button>
        }
        <button className={`btn text-white ${optionSelected === "Guests" ? "btn-secondary" : "btn-primary"}`}
          onClick={() => dispatch(setOptionSelected("Guests"))} >
          Huespedes
        </button>
        <button className={`btn text-white ${optionSelected === "Notes" ? "btn-secondary" : "btn-primary"}`}
          onClick={() => dispatch(setOptionSelected("Notes"))} >
          Notas
        </button>
      </div>
      {optionSelected === "Quotes" && <Quotes individualFile={individualFile} />}
      {optionSelected === "Passengers" && <Passengers individualFile={individualFile} />}
      {optionSelected === "MasterSale" && <MasterSale individualFile={individualFile} />}
      {optionSelected === "Guests" && <Rooming individualFile={individualFile} />}
      {optionSelected === "Notes" && <Notes individualFile={individualFile} />}

    </div>
  )
}
